@if (video(); as video) {
  @let gradientClass =
    "bg-[linear-gradient(180deg,rgba(0,0,0,0)_68.89%,rgba(0,0,0,0.6)_85.22%)] bg-[length:cover] bg-no-repeat";
  @let hasText = !!video.text;
  <div class="relative inset-0 flex size-full items-center">
    @if (isLoading() || !this.isStart() || this.isPlayError()) {
      @if (showPlayButton() || this.isPlayError()) {
        <div (click)="handleOnPlay()" class="absolute inset-0 z-20 flex cursor-pointer items-center justify-center">
          <app-svg [hasShadowCta]="true" [height]="58" [src]="'assets/icons/player.svg'" [width]="58" />
        </div>
      }
      @if (showPoster() || (showPoster() && this.isPlayError())) {
        <div class="absolute inset-0 z-10">
          <app-image
            [image]="video.poster"
            [isPriority]="isImagePriority()"
            [pregenerationSize]="posterPregenerationSize()" />
          @if (hasText) {
            <div [class]="gradientClass" aria-hidden="true" class="pointer-events-none absolute inset-0"></div>
          }
        </div>
      }
    }
    @if (video.text; as text) {
      <div class="pointer-events-none absolute inset-0 z-20 flex items-end px-7 py-6 font-title text-[20px] text-white">
        <span>{{ text }}</span>
      </div>
    }
    @if (videoUrl(); as videoUrl) {
      <video
        #player
        (canplay)="handleCanPlay()"
        (viewportObserver)="handleViewportObserver($event)"
        [class.inset-0]="!keepAspectRatio()"
        [class.object-cover]="!keepAspectRatio()"
        [class.opacity-0]="isLoading()"
        [class.size-full]="!keepAspectRatio()"
        [controls]="showControls()"
        [defaultMuted]="isMuted()"
        [id]="videoId()"
        [loop]="isLoop()"
        [muted]="isMuted()"
        [preload]="autoplay() ? 'auto' : 'metadata'"
        [src]="effectiveSrc()"
        class="absolute z-0"
        playsinline></video>
      @if (hasText) {
        <div [class]="gradientClass" aria-hidden="true" class="pointer-events-none absolute inset-0"></div>
      }
    }
  </div>
}
